import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=0acc76d0&scoped=true&"
import script from "./NotificationList.vue?vue&type=script&lang=js&"
export * from "./NotificationList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotificationList.vue?vue&type=style&index=1&id=0acc76d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc76d0",
  null
  
)

export default component.exports